var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.669,
    height: 30.563,
    viewBox: "0 0 30.669 30.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work-bag-svgrepo-com",
    transform: "translate(0.163)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9606",
    "data-name": "Rectangle 9606",
    width: 28.669,
    height: 23.457,
    transform: "translate(0.837 6.106)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5272",
    "data-name": "Path 5272",
    d: "M29.457,7H1v5.691a3.794,3.794,0,0,0,3.794,3.794H25.662a3.794,3.794,0,0,0,3.794-3.794Z",
    transform: "translate(-0.057 -0.309)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5273",
    "data-name": "Path 5273",
    d: "M8,6.691V2.9A1.9,1.9,0,0,1,9.9,1H21.28a1.9,1.9,0,0,1,1.9,1.9V6.691",
    transform: "translate(-0.417)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 3.909,
    transform: "translate(13.217 15.88)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5274",
    "data-name": "Path 5274",
    d: "M15.9,20.588h0a1.9,1.9,0,0,1-1.9-1.9V14.9A1.9,1.9,0,0,1,15.9,13h0a1.9,1.9,0,0,1,1.9,1.9v3.794A1.9,1.9,0,0,1,15.9,20.588Z",
    transform: "translate(-0.726 -0.617)",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag_icon.8bed016a77aa59ac919e3def0faa4121.svg";
export { ForwardRef as ReactComponent };